// extracted by mini-css-extract-plugin
export default {"assignedToSelect":"AssignedToSelect-index__assignedToSelect--cgFsX"};